(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-header.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-header.js');
"use strict";


const _React = React,
  useCallback = _React.useCallback;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  Button = _svs$ui.ReactButton;
const getProductBrand = svs.components.lbUtils.brandMapping.fn.getProductBrand;
const ProductHeader = svs.components.lbUi.productHeader.ProductHeader;
const QuickplayModalHeader = _ref => {
  let productId = _ref.productId,
    handleClose = _ref.handleClose;
  const _closeOnEnterOrSpace = useCallback(event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClose();
    }
  }, [handleClose]);
  const closeButton = React.createElement(Button, {
    "aria-label": "St\xE4ng",
    className: "padding margin-right p-header-close-btn",
    onClick: handleClose,
    onKeyDown: _closeOnEnterOrSpace,
    transparent: true
  }, React.createElement(Icon, {
    icon: "close",
    size: 300
  }));
  const branding = getProductBrand(productId);
  return React.createElement("div", {
    className: "quickplay-modal-header"
  }, React.createElement("div", {
    className: "f-center no-text-selection"
  }, React.createElement(ProductHeader, {
    branding: branding,
    rightBtnClass: "right-btn-wrapper",
    rightButton: closeButton
  })));
};
setGlobal('svs.components.sport.quickplayModal.QuickplayModalHeader', QuickplayModalHeader);

 })(window);